import { PROFILE_STATUS_ENABLED } from '@advanza/constants'
import { Icon } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import GoLiveRequirementsModal from './GoLiveRequirementsModal'

interface GoLiveRequirementsButtonProps {
    providerId: number
    status: number
}

/**
 * Opens the go-live checklist. Only shown while the profile is not live, since there is nothing
 * left to explain once it is.
 */
const GoLiveRequirementsButton = ({ providerId, status }: GoLiveRequirementsButtonProps) => {
    if (status === PROFILE_STATUS_ENABLED) {
        return null
    }

    return (
        <button
            type="button"
            onClick={() => NiceModal.show(GoLiveRequirementsModal, { providerId })}
            className="mt-2 inline-flex cursor-pointer items-center gap-1 whitespace-nowrap rounded-full border border-solid border-neutral-300 bg-white px-2 py-1 text-sm font-medium text-neutral-700 transition-colors hover:border-neutral-400 hover:bg-neutral-50">
            <Icon name="troubleshoot" fontSize={14} classNameIcon="!text-neutral-500" />
            Why is this profile not live?
        </button>
    )
}

export default GoLiveRequirementsButton
